<mat-card id="geschaeftsvorgangs">
  <div>
    <div class="page-navigation-container">
      <app-side-scrolling [maxLengthOfDisplayed]="maxLengthOfProcesses()"
                          (notifyCurrentSite)="setCurrentProcessSite($event)"
                          (notifyDisplayedSites)="setNumberOfDisplayedPackages($event)"></app-side-scrolling>
    </div>
      <div class="table-container" >
        <table class="az-data-table">
          <thead>
          <tr>
            <th *ngFor="let labelAnzeigeGeschaeftsvorgang of labelGeschaeftsvorgangTabelleHeader">
              {{labelAnzeigeGeschaeftsvorgang.label}}
            </th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let geschaftsvorg of geschaeftsVorgang">
            <tr>
              <td>
                {{geschaftsvorg.anliegenId}}
              </td>
              <td>
                {{geschaftsvorg.ordnungsmerkmalExtern}}
              </td>
              <td>
                {{geschaftsvorg.gevoArtWert}}
              </td>
              <td>
                {{geschaftsvorg.statusWert}}
              </td>
              <td>
                {{geschaftsvorg.vertragIDAllianz}}
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
  </div>
</mat-card>
